function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.421 14h.052C11.263 14 13 12 13 9.5 12.948 6.945 11.263 5 8.526 5S4 6.945 4 9.5C4 12 5.736 14 8.421 14zM4 17h9v26H4zm40 9.5a9.5 9.5 0 00-9.5-9.5 9.474 9.474 0 00-7.5 3.684V17h-9v26h9V28a4 4 0 018 0v15h9V26.5z"
});

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCIgd2lkdGg9IjQ4cHgiIGhlaWdodD0iNDhweCI+PHBhdGggIGQ9Ik04LjQyMSAxNGguMDUyIDBDMTEuMjYzIDE0IDEzIDEyIDEzIDkuNSAxMi45NDggNi45NDUgMTEuMjYzIDUgOC41MjYgNSA1Ljc4OSA1IDQgNi45NDUgNCA5LjUgNCAxMiA1LjczNiAxNCA4LjQyMSAxNHpNNCAxN0gxM1Y0M0g0ek00NCAyNi41YzAtNS4yNDctNC4yNTMtOS41LTkuNS05LjUtMy4wNTMgMC01Ljc2MiAxLjQ0Ni03LjUgMy42ODRWMTdoLTl2MjZoOVYyOGgwYzAtMi4yMDkgMS43OTEtNCA0LTRzNCAxLjc5MSA0IDR2MTVoOUM0NCA0MyA0NCAyNy45NTUgNDQgMjYuNXoiLz48L3N2Zz4K";
export { SvgLinkedin as ReactComponent };